import { useTranslation } from 'react-i18next'
import { EmptyState } from '@node-space/ui-components'
import { ExternalLink } from 'components/ExternalLink/ExternalLink'

export const EarnNoProducts = () => {
  const { t } = useTranslation()

  return (
    <EmptyState
      testId="earn-no-products-empty-state"
      lottieName="permissions-denied"
      title={t('earn.noProductsState.title')}
      description={
        <>
          {t('earn.noProductsState.description')}{' '}
          <ExternalLink href={process.env.EARN_FEATURE_INFO_ARTICLE_URL ?? ''} target="_blank">
            {t('earn.noProductsState.learnMoreLink')}
          </ExternalLink>
        </>
      }
    />
  )
}
